// Fallback görsel: eski WordPress URL'leri (DNS geçişi sonrası) 404 dönüyor.
// Admin panelden yeni fotoğraflar yüklenene kadar bu placeholder gösterilir.
export const FALLBACK_TOUR_IMAGE =
  'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=1200&q=80';

// <img onError={imgErrorFallback} />
export const imgErrorFallback = (e) => {
  if (e.currentTarget.src !== FALLBACK_TOUR_IMAGE) {
    e.currentTarget.src = FALLBACK_TOUR_IMAGE;
  }
};
